import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showNewMessageModal, sendMessage, sendMessageGroups } from '../actions/communication';

export const useCommunication = () => {
  const dispatch = useDispatch();

  const onSendMessage = useCallback(({
    cardIds,
    contentAvailable,
    message,
    playerIds,
    programContentEntryIds,
    translations
  }) => {
    dispatch(sendMessage({
      cardIds,
      contentAvailable,
      message,
      playerIds,
      programContentEntryIds,
      translations,
    }));
  }, [dispatch]);

  const onSendMessageToGroups = useCallback(({
    ages,
    cardIds,
    cohortIds,
    contentAvailable,
    groupIds,
    message,
    programContentEntryIds,
    subgroupIds,
    title,
    translations
  }) => {
    dispatch(sendMessageGroups({
      ages,
      cardIds,
      cohortIds,
      contentAvailable,
      groupIds,
      message,
      programContentEntryIds,
      subgroupIds,
      title,
      translations,
    }));
  }, [dispatch]);

  const newMessageModal = useCallback((params = {}) => {
    dispatch(showNewMessageModal({
      ...params,
      modalCssClass: 'o-communication__modal o-communication__modal--large',
      onSendMessage,
      onSendMessageToGroups,
    }));
  }, [dispatch, onSendMessage, onSendMessageToGroups]);

  return { newMessageModal };
};
